import SlideShow from '../util/SlideShow';

export default {
  init() {
    // JavaScript to be fired on the home page
    document.screen_scroll_target = ( !window.chrome && 'WebkitAppearance' in document.documentElement.style )? $('body') : $('html');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    var scrollTo = function(_target, _speed, _callback) {
      const target = (_target instanceof $) ? _target : $(_target);
      let position = 0;
      if(target.prop('tagName') == 'BODY') {
        position = 0;
      }
      else {
        position = target.position().top;
      }
      document.screen_scroll_target.animate({scrollTop: position}, _speed || 500, 'easeOutQuart', _callback);
    };

    new SlideShow($('.slides'),false).start();
    $(document)
      .on('click', 'a[href*=\\#]', function(e) {
        e.preventDefault();
        const id = '#'+$(e.target).closest('a').attr('href').split('#')[1];
        scrollTo(id);
      });
  }
};
